import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\UpdateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenConfigController.php
* @route '/api/screen-config/{screenConfig}'
*/
const UpdateScreenConfigController = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScreenConfigController.url(args, options),
    method: 'put',
})

UpdateScreenConfigController.definition = {
    methods: ["put"],
    url: '/api/screen-config/{screenConfig}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Screen\UpdateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenConfigController.php
* @route '/api/screen-config/{screenConfig}'
*/
UpdateScreenConfigController.url = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screenConfig: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screenConfig: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screenConfig: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screenConfig: typeof args.screenConfig === 'object'
        ? args.screenConfig.id
        : args.screenConfig,
    }

    return UpdateScreenConfigController.definition.url
            .replace('{screenConfig}', parsedArgs.screenConfig.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\UpdateScreenConfigController::__invoke
* @see app/Http/Controllers/Screen/UpdateScreenConfigController.php
* @route '/api/screen-config/{screenConfig}'
*/
UpdateScreenConfigController.put = (args: { screenConfig: string | number | { id: string | number } } | [screenConfig: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateScreenConfigController.url(args, options),
    method: 'put',
})

export default UpdateScreenConfigController